export const editToolFormNamePrefix = 'edit-tool-form-';

const generateEditToolFormName = uuid => editToolFormNamePrefix + uuid;

export default generateEditToolFormName;
